export enum DialogType {
  Confirm = 'primary',
  Delete = 'error'
}